import tableIcon from './../../images/table-icons.svg';
import { useStyles } from "./styles";
import {useEffect} from "react";

export default function SwitchTableAlert({ onConfirm }) {
    const classes = useStyles();

    const callOnConfirm = () => {
        if (onConfirm)
            onConfirm();
    }

    useEffect(() => {
        document.addEventListener("ordersMoveTableClose", close);
        return () => {
            document.removeEventListener("ordersMoveTableClose", close);
        };
    }, []);

    const close = (event) => {
        callOnConfirm()
    }

    return (
        <div className={classes.SwitchTableAlert}>
            <div className={classes.TableIcon}>
                <img src={tableIcon}/>
            </div>
            <div className={classes.Main}>
                <div>Select table</div>
                <div>Press on the targeted table </div>
            </div>
            <div className={classes.Actions}>
                <button className={classes.CloseBtn} onClick={() => callOnConfirm()}>
                    <i className='bx bx-x'></i>
                </button>
            </div>
        </div>
    );
}
